import { AsyncPipe } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
} from "@angular/core";
import { VipLevelsDirective } from "@Front-end/seed/modules/v2/vip";
import { UserProfileDirective } from "@Front-end/seed/modules/user";
import { PlayerscoreDirective } from "@Front-end/seed/modules/v2/playscore";
import { NgLetDirective } from "@Front-end/ui/directives/ng-let";
import { PictureComponent } from "../picture/picture.component";
import { ResolveMinioUrlMirrorPipe } from "../../../pipes/resolve-minio-url-mirror.pipe";

@Component({
    selector: "ls-account-avatar",
    imports: [
        UserProfileDirective,
        PictureComponent,
        NgLetDirective,
        AsyncPipe,
        PlayerscoreDirective,
        VipLevelsDirective,
        ResolveMinioUrlMirrorPipe,
    ],
    templateUrl: "./account-avatar.component.html",
    styleUrl: "./account-avatar.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountAvatarComponent {

}
